import type { ToastServiceMethods } from 'primevue'

let toastService: ToastServiceMethods | undefined

export const registerToast = (service: ToastServiceMethods) => {
    toastService = service
}

export const PrintSuccess = (message: string) => {
    toastService?.add({ severity: 'success', summary: message, life: 3000 })
}

export const PrintError = (message: string) => {
    toastService?.add({ severity: 'error', summary: message, life: 5000 })
}

export const PrintWarning = (message: string) => {
    toastService?.add({ severity: 'warn', summary: message, life: 6000 })
}
